import { ViewOptionValue } from '../../constants/remediation.constants';

export const ViewOptionValueDisplayTextMap: Record<ViewOptionValue, string> = {
    [ViewOptionValue.ONE_AT_A_TIME]: 'One at a time',
    [ViewOptionValue.ALL_ACTIVITIES]: 'All activities'
}
